import { render, staticRenderFns } from "./DownloadClaimReceiptDialog.vue?vue&type=template&id=0b24a0ca&lang=pug&"
import script from "./DownloadClaimReceiptDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadClaimReceiptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
